import { Injectable, Inject, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { BehaviorSubject, Observable, from, Subject, combineLatest, of } from 'rxjs';
import cubejs, { moveItemInArray, isQueryPresent, movePivotItem, ResultSet, defaultHeuristics } from '@cubejs-client/core';
import { switchMap, catchError } from 'rxjs/operators';
import equal from 'fast-deep-equal';

import * as ɵngcc0 from '@angular/core';
class CubejsClient {
    constructor(config) {
        this.config = config;
        this.ready$ = new BehaviorSubject(false);
        if (this.config instanceof Observable) {
            this.config.subscribe(() => {
                this.ready$.next(true);
            });
        }
        else {
            this.ready$.next(true);
        }
    }
    apiInstance() {
        if (!this.cubeJsApi) {
            if (this.config instanceof Observable) {
                this.config.subscribe((config) => {
                    this.cubeJsApi = cubejs(config.token, config.options);
                    if (!this.cubeJsApi) {
                        throw new Error('Cannot create CubejsApi instance. Please check that the config is passed correctly and contains all required options.');
                    }
                });
            }
            else {
                this.cubeJsApi = cubejs(this.config.token, this.config.options);
            }
        }
        return this.cubeJsApi;
    }
    load(query, options) {
        return from(this.apiInstance().load(query, options));
    }
    sql(query, options) {
        return from(this.apiInstance().sql(query, options));
    }
    dryRun(query, options) {
        return from(this.apiInstance().dryRun(query, options));
    }
    meta(options) {
        return from(this.apiInstance().meta(options));
    }
    watch(query, params = {}) {
        return new Observable((observer) => query.subscribe({
            next: (query) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const resultSet = yield this.apiInstance().load(query, params);
                    observer.next(resultSet);
                }
                catch (err) {
                    observer.error(err);
                }
            }),
        }));
    }
}
CubejsClient.ɵfac = function CubejsClient_Factory(t) { return new (t || CubejsClient)(ɵngcc0.ɵɵinject('config')); };
CubejsClient.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CubejsClient, factory: CubejsClient.ɵfac });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
CubejsClient.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['config',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CubejsClient, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['config']
            }] }]; }, null); })();

class CubejsClientModule {
    static forRoot(config) {
        return {
            ngModule: CubejsClientModule,
            providers: [
                CubejsClient,
                {
                    provide: 'config',
                    useValue: config,
                },
            ],
        };
    }
}
CubejsClientModule.ɵfac = function CubejsClientModule_Factory(t) { return new (t || CubejsClientModule)(); };
CubejsClientModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CubejsClientModule });
CubejsClientModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [CubejsClient] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CubejsClientModule, [{
        type: NgModule,
        args: [{
                providers: [CubejsClient]
            }]
    }], null, null); })();

class StateSubject {
    constructor(value) {
        this.subject = new BehaviorSubject(value);
    }
    get() {
        return this.subject.getValue();
    }
    set(value) {
        this.subject.next(value);
    }
}

class BaseMember {
    constructor(query, field) {
        this.query = query;
        this.field = field;
    }
    get members() {
        return this.query.asCubeQuery()[this.field] || [];
    }
    add(name) {
        this.query.setPartialQuery({
            [this.field]: [...this.members, name],
        });
    }
    replace(name, replaceWithName) {
        this.query.setPartialQuery({
            [this.field]: this.members.map((currentName) => currentName === name ? replaceWithName : currentName),
        });
    }
    remove(by) {
        this.query.setPartialQuery({
            [this.field]: this.query
                .asCubeQuery()[this.field].filter((currentName, index) => {
                if (typeof by === 'string') {
                    return currentName !== by;
                }
                return index !== by;
            }),
        });
    }
    set(members) {
        this.query.setPartialQuery({
            [this.field]: members,
        });
    }
    asArray() {
        return (this.query.asCubeQuery()[this.field] || []).map((name) => this.query.meta.resolveMember(name, this.field));
    }
}
class TimeDimensionMember {
    constructor(query) {
        this.query = query;
    }
    get members() {
        return this.query.asCubeQuery().timeDimensions || [];
    }
    get granularity() {
        var _a;
        return (_a = this.members[0]) === null || _a === void 0 ? void 0 : _a.granularity;
    }
    updateTimeDimension(by, updateWith) {
        const timeDimensions = this.members.map((td, index) => {
            if (td.dimension === by || index === by) {
                return Object.assign(Object.assign({}, td), updateWith);
            }
            return td;
        });
        this.query.setPartialQuery({
            timeDimensions,
        });
    }
    add(name) {
        this.query.setPartialQuery({
            timeDimensions: [
                {
                    dimension: name,
                },
            ],
        });
    }
    remove(name) {
        this.query.setPartialQuery({
            timeDimensions: this.members.filter(({ dimension }) => dimension !== name),
        });
    }
    set(timeDimensions) {
        this.query.setPartialQuery({
            timeDimensions,
        });
    }
    setDateRange(by, dateRange) {
        this.updateTimeDimension(by, { dateRange });
    }
    setGranularity(by, granularity) {
        this.updateTimeDimension(by, { granularity });
    }
    asArray() {
        return (this.query.asCubeQuery().timeDimensions || []).map((td) => {
            return Object.assign(Object.assign({}, this.query.meta.resolveMember(td.dimension, 'dimensions')), td);
        });
    }
}
class Order {
    constructor(query) {
        this.query = query;
        this.orderMembers = new BehaviorSubject([]);
        this.query.subject.subscribe(this.handleQueryChange.bind(this));
        this.orderMembers.subscribe(this.handleOrderMembersChange.bind(this));
    }
    handleOrderMembersChange(orderMembers) {
        const order = orderMembers
            .filter(({ order }) => order !== 'none')
            .reduce((memo, { id, order }) => (Object.assign(Object.assign({}, memo), { [id]: order })), {});
        if (!equal(order, this.asObject())) {
            this.query.setPartialQuery({ order });
        }
    }
    handleQueryChange() {
        this.orderMembers.next([
            ...this.query.measures.asArray(),
            ...this.query.dimensions.asArray(),
            ...this.query.timeDimensions.asArray(),
        ].map(({ name, title }) => {
            return {
                id: name,
                order: this.of(name),
                title,
            };
        }));
    }
    setMemberOrder(id, order) {
        this.orderMembers.next(this.orderMembers.getValue().map((orderMember) => {
            if (orderMember.id === id) {
                return Object.assign(Object.assign({}, orderMember), { order });
            }
            return orderMember;
        }));
    }
    reorder(sourceIndex, destinationIndex) {
        this.orderMembers.next(moveItemInArray(this.orderMembers.getValue(), sourceIndex, destinationIndex));
    }
    of(member) {
        return (this.query.asCubeQuery().order || {})[member] || 'none';
    }
    set(order) {
        this.query.setPartialQuery({ order });
    }
    asArray() {
        if (Array.isArray(this.query.asCubeQuery().order)) {
            return this.query.asCubeQuery().order;
        }
        return Object.entries(this.query.asCubeQuery().order || {});
    }
    asObject() {
        return this.asArray().reduce((memo, [key, value]) => (Object.assign(Object.assign({}, memo), { [key]: value })), {});
    }
}
class FilterMember {
    constructor(query) {
        this.query = query;
    }
    get filters() {
        // TODO: update this type assertion once the QueryBuilder supports logical and/or
        return (this.query.asCubeQuery().filters || []);
    }
    update(by, updateWith) {
        const filters = this.filters.map((filter, index) => {
            if (index === by || filter.member === by || filter.dimension === by) {
                return Object.assign(Object.assign({}, filter), updateWith);
            }
            return filter;
        });
        this.query.setPartialQuery({
            filters: filters,
        });
    }
    add(filter) {
        this.query.setPartialQuery({
            filters: [...this.filters, filter],
        });
    }
    remove(by) {
        this.query.setPartialQuery({
            filters: this.filters.filter((filter, index) => {
                if (filter.member === by || filter.dimension === by || index === by) {
                    return false;
                }
                return true;
            }),
        });
    }
    set(filters) {
        this.query.setPartialQuery({
            filters,
        });
    }
    replace(name, replaceWithName) {
        this.query.setPartialQuery({
            filters: this.filters.map((filter) => {
                const field = filter.member ? 'member' : 'dimension';
                return filter.member === name || filter.dimension === name
                    ? Object.assign(Object.assign({}, filter), { [field]: replaceWithName }) : filter;
            }),
        });
    }
    asArray() {
        return this.filters.map((filter) => {
            return Object.assign(Object.assign(Object.assign({}, this.query.meta.resolveMember(filter.member || filter.dimension, [
                'dimensions',
                'measures',
            ])), { operators: this.query.meta.filterOperatorsForMember(filter.member || filter.dimension, ['dimensions', 'measures']) }), filter);
        });
    }
}

var MemberType;
(function (MemberType) {
    MemberType["Measures"] = "measures";
    MemberType["Dimensions"] = "dimensions";
    MemberType["Segments"] = "segments";
    MemberType["TimeDimensions"] = "timeDimensions";
    MemberType["Filters"] = "filters";
    MemberType["Order"] = "order";
})(MemberType || (MemberType = {}));
class Query extends StateSubject {
    constructor(meta, _onBeforeChange = (newQuery) => newQuery) {
        super({});
        this.meta = meta;
        this._onBeforeChange = _onBeforeChange;
        this.init();
    }
    init() {
        this.measures = new BaseMember(this, MemberType.Measures);
        this.dimensions = new BaseMember(this, MemberType.Dimensions);
        this.segments = new BaseMember(this, MemberType.Segments);
        this.timeDimensions = new TimeDimensionMember(this);
        this.filters = new FilterMember(this);
        this.order = new Order(this);
    }
    asCubeQuery() {
        return this.subject.getValue() || {};
    }
    setQuery(query) {
        this.subject.next(this._onBeforeChange(query, this.subject.getValue(), this));
    }
    setPartialQuery(partialQuery) {
        this.subject.next(this._onBeforeChange(Object.assign(Object.assign({}, this.subject.getValue()), partialQuery), this.subject.getValue(), this));
    }
    setLimit(limit) {
        this.setPartialQuery({ limit });
    }
    isPresent() {
        return isQueryPresent(this.asCubeQuery());
    }
}

class BuilderMeta {
    constructor(meta) {
        this.meta = meta;
        this.mapMeta();
    }
    mapMeta() {
        const allDimensions = (this.meta.membersForQuery(null, 'dimensions'));
        this.measures = this.meta.membersForQuery(null, 'measures');
        this.segments = this.meta.membersForQuery(null, 'segments');
        this.dimensions = allDimensions.filter(({ type }) => type !== 'time');
        this.timeDimensions = allDimensions.filter(({ type }) => type === 'time');
        this.filters = [...allDimensions, ...this.measures].map((member) => {
            return Object.assign(Object.assign({}, member), { operators: this.meta.filterOperatorsForMember(member.name, [
                    'dimensions',
                    'measures',
                ]) });
        });
    }
}

class PivotConfig extends StateSubject {
    constructor(pivotConfig) {
        super(pivotConfig);
    }
    moveItem(sourceIndex, destinationIndex, sourceAxis, destinationAxis) {
        this.subject.next(movePivotItem(this.get(), sourceIndex, destinationIndex, sourceAxis, destinationAxis));
    }
    setFillMissingDates(fillMissingDates) {
        this.subject.next(Object.assign(Object.assign({}, this.get()), { fillMissingDates }));
    }
}

class ChartType extends StateSubject {
    constructor(value) {
        super(value);
    }
}

class QueryBuilderService {
    constructor() {
        this._disableHeuristics = false;
        this._heuristicChange$ = new Subject();
        this.builderMeta = new Promise((resolve) => (this._resolveBuilderMeta = resolve));
        this.query = new Promise((resolve) => (this._resolveQuery = resolve));
        this.state = new BehaviorSubject({});
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.pivotConfig = new PivotConfig(null);
            this.chartType = new ChartType('line');
            this._cubejs.meta().subscribe((meta) => {
                this._meta = meta;
                this._query = new Query(this._meta, this._handleQueryChange.bind(this));
                this._resolveQuery(this._query);
                this._resolveBuilderMeta(new BuilderMeta(this._meta));
            });
            this.subscribe();
            if (!this._disableHeuristics) {
                this._heuristicChange$
                    .pipe(switchMap((data) => {
                    return combineLatest([
                        this._cubejs.dryRun(data.query).pipe(catchError((error) => {
                            console.error(error);
                            return of(null);
                        })),
                        of(data.shouldApplyHeuristicOrder),
                    ]);
                }))
                    .subscribe(([dryRunResponse, shouldApplyHeuristicOrder]) => {
                    if (!dryRunResponse) {
                        return;
                    }
                    const { pivotQuery, queryOrder } = dryRunResponse;
                    this.pivotConfig.set(ResultSet.getNormalizedPivotConfig(pivotQuery, this.pivotConfig.get()));
                    if (shouldApplyHeuristicOrder) {
                        this._query.order.set(queryOrder.reduce((a, b) => (Object.assign(Object.assign({}, a), b)), {}));
                    }
                });
            }
        });
    }
    _handleQueryChange(newQuery, oldQuery) {
        var _a, _b;
        const { chartType, shouldApplyHeuristicOrder, query: heuristicQuery, } = defaultHeuristics(newQuery, oldQuery, {
            meta: this._meta,
            sessionGranularity: (_b = (_a = newQuery === null || newQuery === void 0 ? void 0 : newQuery.timeDimensions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.granularity,
        });
        const query = this._disableHeuristics
            ? newQuery
            : heuristicQuery || newQuery;
        if (isQueryPresent(query) && !this._disableHeuristics) {
            this._heuristicChange$.next({
                shouldApplyHeuristicOrder: Boolean(shouldApplyHeuristicOrder),
                query,
            });
        }
        if (!this._disableHeuristics && chartType) {
            this.chartType.set(chartType);
        }
        return query;
    }
    setCubejsClient(cubejsClient) {
        this._cubejs = cubejsClient;
        this.init();
    }
    subscribe() {
        Object.getOwnPropertyNames(this).forEach((key) => {
            if (this[key] instanceof StateSubject) {
                this[key].subject.subscribe((value) => this.setPartialState({
                    [key]: value,
                }));
            }
        });
        this.query.then((query) => {
            query.subject.subscribe((cubeQuery) => {
                this.setPartialState({
                    query: cubeQuery,
                });
            });
        });
    }
    deserialize(state) {
        return __awaiter(this, void 0, void 0, function* () {
            if (state.query) {
                (yield this.query).setQuery(state.query);
            }
            Object.entries(state).forEach(([key, value]) => {
                if (this[key] instanceof StateSubject) {
                    this[key].set(value);
                }
            });
            this.subscribe();
        });
    }
    setPartialState(partialState) {
        this.state.next(Object.assign(Object.assign({}, this.state.getValue()), partialState));
    }
    disableHeuristics() {
        this._disableHeuristics = false;
    }
    enableHeuristics() {
        this._disableHeuristics = true;
    }
}
QueryBuilderService.ɵfac = function QueryBuilderService_Factory(t) { return new (t || QueryBuilderService)(); };
QueryBuilderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: QueryBuilderService, factory: QueryBuilderService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QueryBuilderService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/*
 * Public API Surface of cubejs-client-ngx
 */

// This file is not used to build this module. It is only used during editing

/**
 * Generated bundle index. Do not edit.
 */

export { BaseMember, BuilderMeta, ChartType, CubejsClient, CubejsClientModule, FilterMember, MemberType, Order, PivotConfig, Query, QueryBuilderService, TimeDimensionMember, StateSubject as ɵa };

